export default __webpack_public_path__ + "static/media/ordoAgreementForm.2678684b.pdf";